import { createFileRoute } from '@tanstack/react-router'
import { Trans } from '@lingui/react/macro'
import { getBrandConfig } from '@/config/config'
import { AccountLockedHeader } from '@/features/account-locked/account-locked-header'
import { AccountLockedLinks } from '@/features/account-locked/account-locked-links'

export const Route = createFileRoute(
  '/_app/account-locked/verification-required',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { name: brandName } = getBrandConfig()

  return (
    <>
      <AccountLockedHeader
        heading={<Trans>Verification Required</Trans>}
        description={
          <>
            <p className="mb-3">
              <Trans>
                As part of our ongoing compliance requirements, we need to
                verify your identity.
              </Trans>
            </p>
            <p>
              <Trans>Verify now to continue playing in {brandName}.</Trans>
            </p>
          </>
        }
      />
      <AccountLockedLinks accountVerification />
    </>
  )
}
